/* tslint:disable */
/* eslint:disable */

import * as React from 'react';
import { withRouter } from 'react-router';
import { inject, observer } from 'mobx-react';

export class ActiveReportsComponent extends React.Component{

    viewer;

    state = {
        reportList: [],
        activeReportName: '',
    }
    RootStore;
    API;
    constructor(props) {
        super(props);
        this.RootStore = this.props.stores;
        this.API = this.RootStore.Api;
    }
    injectScriptDependencies = () => {
        let link = document.createElement('link');
        link.rel='stylesheet'
        link.href='https://cdn.materialdesignicons.com/2.8.94/css/materialdesignicons.min.css';
        link.className= 'myclass';
        document.head.appendChild(link);
        link = document.createElement('link');
        link.rel='stylesheet'
        link.href="/assets/css/bootstrap.css";
        link.className= 'myclass';
        document.head.appendChild(link);
        link = document.createElement('link');
        link.rel='stylesheet'
        link.href="/assets/css/bootstrap-datetimepicker.css";
        link.className= 'myclass';
        document.head.appendChild(link);
        link = document.createElement('link');
        link.rel='stylesheet'
        link.href="/assets/css/theme-cosmo.css";
        link.className= 'myclass';
        document.head.appendChild(link);
        link = document.createElement('link');
        link.rel='stylesheet'
        link.href="/assets/css/site.css";
        link.className= 'myclass';
        document.head.appendChild(link);
        link = document.createElement('link');
        link.rel='stylesheet'
        link.href="/assets/css/GrapeCity.ActiveReports.Viewer.Html.css";
        link.className= 'myclass';
        document.head.appendChild(link);

        
        const scripts = [
            '/assets/scripts/bootstrap-3.0.0.js',
            '/assets/scripts/knockout-2.3.0.js',
            '/assets/scripts/GrapeCity.ActiveReports.Viewer.Html.js',
        ];
        
        return this.injectScript('/assets/scripts/jquery-1.10.2.js').then(() => {
            const allOtherScripts = scripts.map(item => this.injectScript(item));
            return Promise.all(allOtherScripts);
        })
                
    }

    injectCss(src) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = src;
        link.className = 'myclass';
        document.head.appendChild(link);
    }

    injectScript(src) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.async = false;
            script.src = src;
            script.className = 'myclass';
            script.addEventListener('load', resolve);
            script.addEventListener('error', () => reject('Error loading script.'));
            script.addEventListener('abort', () => reject('Script loading aborted.'));
            document.head.appendChild(script);
        });
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const reportName = searchParams.get('name');
        const reportWell = searchParams.get('well');
        this.injectScriptDependencies()
        .then(() => {
            return this.API.get('/reports/activereporttoken')
            .then(response => {
                this.viewer = this.loadViewer(response.token);
                return response.token;
            })
            .then(token => {
                // initialize code from 'beforeload'
                const serverUrl = 'https://mudman-activereports.novamudlabs.com/api/reports';
                return fetch(serverUrl, {
                    method: 'GET',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        'AuthToken': token,
                    },
                })
            })
            .then(resp => {
                if (resp.ok) {
                    return resp.json();
                }
                throw new Error('Error in list json');
            })
            .then(jsonResp => {
                this.setState({
                    reportList: jsonResp,
                });
            });
        })
        .then(() => {
            const reportOptions = {
            };
            if (reportWell) {
                reportOptions.parameters = [
                    {
                        name: 'PWellName',
                        value: reportWell,
                    }
                ]
            }
            if (reportName) {
                reportOptions.id = reportName;
                this.viewer.option('report', reportOptions);
            }

        })
    }
    
    loadViewer = (_token) => {
        return window.GrapeCity.ActiveReports.Viewer({
            element: '#viewer',
            reportService: {
                url: "https://mudman-activereports.novamudlabs.com/api/",
                securityToken: _token,
                resourceHandler: "https://mudman-activereports.novamudlabs.com/cache/"
            },
            report: {
                id: 'recap_mudmetrix'
            },
            uiType: "desktop",
        });
    }
    componentWillUnmount() {
        // cleanup code from 'beforeunload'
        this.viewer.destroy();
        const removeScripts = document.getElementsByClassName('myclass');
        while (removeScripts.length>0) {
            removeScripts[0].remove();
        }
    }

    handleReportChange = (event) => {
        this.setState({
            activeReportName: event.target.value,
        });
        this.viewer.option('report', {
            id: event.target.value
        });
    }

    render() {
        return (
            <div className="report-spanheight" style={{height: '88vh'}}>
                <h4 style={{fontSize: '26px'}}>Active Reports</h4>
                {/* <h6>
                    Select a Report: {' '}
                    <select
                        type="select"
                        name="reportList"
                        value={this.state.activeReportName}
                        onChange={this.handleReportChange}
                    >
                        <option />
                        {
                            this.state.reportList.map(item => 
                                <option key={item._id} value={item.Name}>{item.Name}</option>
                            )
                        }
                    </select>
                </h6> */}
                <div className="theme-default" id="viewer" style={{height: '100%'}}>Loading Report</div>
            </div>
        );
    }
}

export default inject('stores')(observer(withRouter(ActiveReportsComponent)));


// WEBPACK FOOTER //
// ./src/Components/Reporting/ActiveReports/ActiveReports.jsx